import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,

    ReportService
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./POvsGRN.html",
})
export class POVsGRNReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];

  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partyList$ = [];
  dataList: any[];
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    grn_no: "",
    inv_no: "",
    party_name: "",
    grn_from_date: "",
    grn_to_date: "",
    inv_from_date: "",
    inv_to_date: "",
    fin_id: "",
    groupby: "DESIGN WISE",
    grn_type: "PENDING",
  };
  reportTypeList = ["DESIGN WISE", "PARTY"];
  grntypeList = ["BULK", "SAMPLE", "PENDING"];
  exceldata: any;
  finyearList = [];
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public toasterService: ToasterService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          //  this.getLragainstgrnReport();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Grn no",
        prop: "grn_no",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Inv no",
        prop: "invoice_no",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "GRN Date",
        prop: "grn_date",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Date",
        prop: "invoice_date",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Invoice Name",
        prop: "party_name",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        sortable: false,
        headerClass: "text-center",
        cellClass: "text-left",
      },
      {
        name: "Design",
        prop: "design_no",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "Inv Mtrs",
        prop: "qty",
        summary: "sum",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "GRN Mtrs",
        prop: "grn_qty",
        summary: "sum",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Rate",
        prop: "rate",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "GRN Rate",
        prop: "grn_rate",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "Inv Amt",
        prop: "amount",
        summary: "sum",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
      {
        name: "GRN Amt",
        prop: "grn_amt",
        summary: "sum",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        align: "right",
        type: "number",
        headerClass: "text-center",
        cellClass: "text-right",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.finyearCombo();

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    // this.getLragainstgrnReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    //this.getLragainstgrnReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getLragainstgrnReport();
  }

  /*  onbackbutton(group){
        this.filterData.groupby ='DESIGN WISE';
     
        this.getLragainstgrnReport();
  
    }

    onCellClick(event) {
         // this.filterData.inv_no = event.row.invoice_no;
          this.filterData.groupby = 'DESIGN WISE';
          this.getLragainstgrnReport();
    }
 */
  getLragainstgrnReport(): void {
    if (this.filterData.grn_from_date == "") {
      this.filterData.grn_from_date = "";
    } else {
      this.filterData.grn_from_date = this.datePipe.transform(
        this.filterData.grn_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.grn_to_date == "") {
      this.filterData.grn_to_date = "";
    } else {
      this.filterData.grn_to_date = this.datePipe.transform(
        this.filterData.grn_to_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.inv_from_date == "") {
      this.filterData.inv_from_date = "";
    } else {
      this.filterData.inv_from_date = this.datePipe.transform(
        this.filterData.inv_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filterData.inv_to_date == "") {
      this.filterData.inv_to_date = "";
    } else {
      this.filterData.inv_to_date = this.datePipe.transform(
        this.filterData.inv_to_date,
        "yyyy-MM-dd"
      );
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_name: this.filterData.party_name,
      inv_no: this.filterData.inv_no,
      grn_no: this.filterData.grn_no,
      grn_from_date: this.filterData.grn_from_date,
      grn_to_date: this.filterData.grn_to_date,
      inv_from_date: this.filterData.inv_from_date,
      inv_to_date: this.filterData.inv_to_date,
      fin_id: this.filterData.fin_id,
      groupby: this.filterData.groupby,
      grn_type: this.filterData.grn_type,
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.reportService
      .getPOVsGRNreport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.invoiceData = res.data;

        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        that.printConfig = {
          title: "LR Against GRN Report",
          sumtitle: "TOTAL",
          columns: res.columns,
          rows: res.data,
        };
        that.exceldata = that.getData(that.columns, res.data);
      });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filterData.fin_id = res.data[0].fin_id;
      that.getLragainstgrnReport();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  clearFilter(): void {
    (this.filterData.grn_no = ""),
      (this.filterData.inv_no = ""),
      (this.filterData.party_name = ""),
      (this.filterData.grn_from_date = ""),
      (this.filterData.grn_to_date = ""),
      (this.filterData.inv_from_date = ""),
      (this.filterData.inv_to_date = "");
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getLragainstgrnReport();
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/POagainstGRN/POvsGRN.ts